import { Box, SectionHelper, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import React from 'react';
import { usePanelStateAtom } from '../../../hooks/rules-state';
import { useGlobalSectionState } from '../../../rule-mappers/shared/use-global-section-state';
import { useVerify } from '../../../rule-mappers/shared/use-verify';
export const HeadingStructureRuleNoHeadings = _ref => {
  let {
    pageId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    verify
  } = useVerify({});
  const {
    getGroupData,
    panelState
  } = usePanelStateAtom();
  const {
    getGlobalSectionModifiedComponentIds
  } = useGlobalSectionState();
  const groupData = getGroupData(pageId);
  return /*#__PURE__*/React.createElement(SectionHelper, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0 4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      bold: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "normal",
        secondary: true
      }),
      underline: /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        skin: "dark",
        underline: "always",
        onClick: async () => {
          assertNotOptional(groupData, 'groupData');
          await verify(groupData, getGlobalSectionModifiedComponentIds(panelState.globalSectionComponentsDataMap));
        }
      })
    },
    i18nKey: "accessibility-wizard.rules-list.heading-definition.no-headings.section-helper-content",
    t: t
  }))));
};
//# sourceMappingURL=heading-structure-rule-no-headings.js.map